/**
 * Shared styled components for Uploaded Image Rows
 * Used across 45+ cover image variation components
 */
import styled from 'styled-components';

import { Textarea } from '@/components/Forms';

export const ImagesRow = styled.div`
  display: flex;
  border: solid 1px ${({ theme }) => theme.colors.grayscale};
  padding: 16px;
  width: 100%;
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const ImageHolder = styled.div`
  display: flex;
  align-items: center;
`;

export const Img = styled.img<{ $width?: number; $height?: number; $circular?: boolean }>`
  border-radius: ${({ $circular }) => ($circular ? '50%' : '6px')};
  width: 76px;
  height: 80px;
  flex-shrink: 0;
  object-fit: cover;
  ${({ $width }) =>
    $width &&
    `
    width: ${$width}px;
  `};
  ${({ $height }) =>
    $height &&
    `
    height: ${$height}px;
  `};
`;

export const FullImg = styled.img`
  border-radius: 6px;
  width: 152px;
  height: 80px;
  flex-shrink: 0;
  object-fit: cover;
`;

export const Buttons = styled.div`
  display: flex;
  gap: 12px;
`;

export const ActionButton = styled.button`
  color: ${({ theme }) => theme.colors.gray};
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all ease 0.2s;
  border-radius: 50%;
  &:hover {
    color: ${({ theme }) => theme.colors.black};
    background-color: ${({ theme }) => theme.colors.grayscaleLight};
  }
`;

export const DeleteButton = styled(ActionButton)`
  &:hover {
    color: ${({ theme }) => theme.colors.error};
    background-color: ${({ theme }) => theme.colors.errorLight};
  }
`;

export const StyledTextarea = styled(Textarea)`
  height: 80px;
`;
